var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_501_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16V-3.8743e-07H24V16H0Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16L24 -3.8743e-07L0 16ZM24 16L0 -3.8743e-07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3167 8.00007L-0.536682 14.569L0.536631 17.4312L12 9.78892L23.4633 17.4312L24.5366 14.569L14.6833 8.00007L24.5366 1.43115L23.4633 -1.43101L12 6.21122L0.536631 -1.43101L-0.536682 1.43115L9.3167 8.00007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16L24 -3.8743e-07L0 16ZM24 16L0 -3.8743e-07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2111 8.00004L-0.357788 15.046L0.357754 16.9541L12 9.19261L23.6422 16.9541L24.3578 15.046L13.7888 8.00004L24.3578 0.954097L23.6422 -0.954016L12 6.80747L0.357754 -0.954016L-0.357788 0.954097L10.2111 8.00004Z",
    fill: "#CF142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16V-3.8743e-07V16ZM0 8H24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5.33333V-3.8743e-07H10V5.33333H0V10.6667H10V16H14V10.6667H24V5.33333H14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16V-3.8743e-07V16ZM0 8H24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 6.4V-3.8743e-07H10.8V6.4H0V9.6H10.8V16H13.2V9.6H24V6.4H13.2Z",
    fill: "#CF142B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.a1c5e7f2eebd5268a6a767ccd0be7957.svg";
export { ForwardRef as ReactComponent };